module.exports = __webpack_public_path__ + "media/custom/images/pocstock-signup-enterprise-66782f0ada24b9106012cca2fecebf35.png";